export default "__VITE_ASSET__DwizGDJw__"